import React, { useState, useRef, useEffect, useContext } from 'react';
import './oldModal.scss';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { func, string, number, bool, object } from 'prop-types';
import _ from 'lodash';
import Input from '../../common/Input';
import { Errors } from '../../../constants/errors';
import {
  setSavedDrugClick,
  setSavedLinkClick
} from '../../../actions/userDrug';
import {
  validateMail,
  checkUserStatus
} from '../../../services/Api/User/UserService';
import EnterPassWordModal from './EnterPassWordModal.js';
import EmailSentModal from './EmailSentModal.js';
import SignupHomeDelivery from './SignupHomeDelivery/index.js';
import DialogCloseButton from '../../common/Dialog/DialogCloseButton';
import Dialog from '../../common/Dialog';
import { useSelector, useDispatch } from 'react-redux';
import ReferralSignupSuccess from '../../Referral/SignupSuccessModal';
import { useHistory } from 'react-router-dom';
import { PUBLIC_ROUTE_REGEX } from '../../../constants/defaults.js';
import { AuthContext } from '../../../Contexts.js';

const AuthenticateModal = ({
  hideAuthenticateModal,
  redirectUri,
  quantity,
  isFromHomeDelivery,
  referrerUser,
  skipEmailScreen,
  isSigninClick,
  emailFromDLDBanner = ''
}) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const closeButtonRef = useRef();
  let lang = i18n.language;
  const [emailData, setEmail] = useState({
    email: '',
    emailErr: '',
    emailKickboxErr: false
  });
  const [showLoader, setLoader] = useState(false);
  const [userState, setUserState] = useState(-1);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [signupResponse, setSignupResponse] = useState({});

  const { email, emailErr } = emailData;
  const dispatch = useDispatch();
  const context = useContext(AuthContext);

  const savedLinkClicked = useSelector(
    state => state.userDrugs.savedLinkClicked
  );

  const savedDrugClicked = useSelector(
    state => state.userDrugs.savedDrugClicked
  );

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    if (skipEmailScreen || !_.isEmpty(emailFromDLDBanner)) {
      triggerGTMEvent();
      setEmail({
        ...emailData,
        email: referrerUser.email ? referrerUser.email : emailFromDLDBanner,
        emailKickboxErr: false
      });
      checkEmailSetState(
        referrerUser.email ? referrerUser.email : emailFromDLDBanner
      );
    } else {
      setUserState(0);
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const checkEmailSetState = async email => {
    const checkEmailResponse = await checkUserStatus(email);
    if (checkEmailResponse.exists && checkEmailResponse.isPasswordSet) {
      setUserState(1);
    } else if (checkEmailResponse.exists && !checkEmailResponse.isPasswordSet) {
      setUserState(2);
    } else if (
      !checkEmailResponse.exists &&
      !checkEmailResponse.isPasswordSet
    ) {
      setUserState(3);
    }
  };

  const triggerGTMEvent = () => {
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpSubmitEmail',
      formId: 'loyalty step 1'
    });
  };

  const handleError = (name, type) => {
    _.setError(setEmail, emailData, name, type);
  };

  const handleEmailBlur = event => {
    const { value } = event.target;
    let err = '';
    if (!_.validateEmail(value)) {
      err = _.isEmpty(value.trim()) ? Errors.Required : Errors.Email;
    }
    setEmail({
      ...emailData,
      email: value,
      emailErr: err,
      emailKickboxErr: false
    });
  };

  const handleContinueClick = async event => {
    event.preventDefault();
    if (!_.validateEmail(email)) {
      _.isEmpty(email.trim())
        ? handleError('email', 'Required')
        : handleError('email', 'Email');
      return;
    } else {
      handleError('email', '');
    }
    triggerGTMEvent();
    setLoader(true);
    const responseData = await validateMail(email);
    if (responseData && _.isEqual(responseData.result, 'undeliverable')) {
      setEmail({
        ...emailData,
        emailErr: Errors.Email,
        emailKickboxErr: true
      });
    } else {
      await checkEmailSetState(email);
    }
    setLoader(false);
  };

  const redirectUrl = url => {
    return _.isEmpty(url)
      ? ''
      : url.replace(
          new RegExp(
            '{{DisplayQuantity}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
            'g'
          ),
          quantity
        );
  };

  const handleConfirmation = () => {
    if (!_.isEmpty(signupResponse)) {
      _.setUserData({}, dispatch, savedLinkClicked);
      context?.setUserData(signupResponse?.data);
      _.setUserPoints(signupResponse, dispatch);
      isFromHomeDelivery
        ? window.open(redirectUrl(redirectUri), '_self')
        : history.location.pathname.match(
            /how-it-works|como-funciona-singlecare/
          ) && history.push(_.withLocale(lang, '/'));
      if (history.location.pathname.match(PUBLIC_ROUTE_REGEX)) {
        history.push(_.withLocale(lang, '/'));
      }
    }
    hideAuthenticateModal();
  };

  const hideAuthenticateModalAfterSignup = data => {
    setSignupResponse(data);
    if (!_.isEmpty(_.getCookie('refCode'))) {
      _.eraseCookie('refCode');
      setUserState(4);
      handleConfirmation();
    } else {
      setConfirmationModal(true);
    }
  };
  const referralSignupCloseHandler = () => {
    hideAuthenticateModal();
  };

  const handleEmailChange = event => {
    const { value } = event.target;
    setEmail({
      ...emailData,
      email: value,
      emailKickboxErr: false
    });
  };

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (
        (relatedClassName.includes('noBorder') ||
          relatedClassName.includes('dialogComponent') ||
          relatedClassName.includes('sc-form__text')) &&
        !relatedClassName.includes('site-search-form--term')
      ) {
        return;
      } else {
        closeButtonRef.current.focus();
      }
    }
  };

  const getHeading = () => {
    let heading = isSigninClick ? (
      `${t('Welcome back to SingleCare')}`
    ) : (
      <React.Fragment>
        {t('Members get our lowest prices')}
        <span>
          {t('Sign-up-new')}&nbsp;<strong>{t('FREE')}</strong>&nbsp;
          {t('to get exclusive discounts')}
        </span>
      </React.Fragment>
    );
    savedDrugClicked &&
      (heading = `${t('Log in or sign up to save this')}${' '}${t('drug')}`);
    savedLinkClicked &&
      (heading = `${t('Log in or sign up to save this')}${' '}${t('coupon')}`);
    return (
      <h2 className="headingMargin" id="dialogTitleHeading">
        {heading}
      </h2>
    );
  };

  const handleModalClose = () => {
    dispatch(setSavedLinkClick(false));
    dispatch(setSavedDrugClick(false));
    confirmationModal ? handleConfirmation() : hideAuthenticateModal();
  };

  return (
    <React.Fragment>
      {userState < 4 ? (
        <div
          tabIndex="0"
          className={`mainModal ${isFromHomeDelivery && 'drugHomeDelivery'} ${
            (userState === 0 && 'homeDeliveryModalNew') ||
            (userState === 1 && 'enterPassWordModal') ||
            (userState === 2 && 'emailSentModal') ||
            (userState === 3 && !confirmationModal
              ? 'signupHomeDeliveryModal'
              : '')
          } ${confirmationModal && 'confirmationMainModal'}`}
        >
          <div
            className="transparentBg"
            onClick={() => handleModalClose()}
          ></div>
          <Dialog
            className="modalContent textCenter"
            onBlur={setFocusToCloseButton}
            escKeyFunction={
              confirmationModal ? handleConfirmation : hideAuthenticateModal
            }
            isModalOpen={userState < 4 ? true : false}
            ariaLive={confirmationModal}
          >
            <div className="modalContentHeader">
              <DialogCloseButton
                ref={closeButtonRef}
                className="closeModal"
                onClick={() => handleModalClose()}
                img="icon-close-white.svg"
                alt=""
              />
            </div>
            {confirmationModal ? (
              <div className="confirmationModal">
                <img
                  src="/content/images/icons/logoIcon.svg"
                  alt=""
                  width={48}
                  height={48}
                />
                <h1>{t('Welcome to SingleCare')}</h1>
                <span>{t('Discover the lowest prices')}</span>
                <button
                  className="dialogComponent"
                  onClick={() => handleConfirmation()}
                >
                  {t('Continue')}
                </button>
              </div>
            ) : (
              <>
                {userState === 0 && (
                  <div>
                    {isFromHomeDelivery ? (
                      <div>
                        <h2 id="dialogTitleHeading" className="deliveyHeading">
                          <span>
                            <img
                              src="/content/images/homeDelivery/step3.png"
                              className="boxImg"
                              alt=""
                            />
                          </span>
                          {t('Get home delivery')}
                        </h2>
                        <p>{t('Enter your email to get started')}</p>
                        <ul>
                          <li>
                            <span>
                              <img
                                src="/content/images/homeDelivery/truck.svg"
                                alt=""
                              />
                            </span>
                            {t('AuthModal-Free shipping, always')}
                          </li>
                          <li>
                            <span>
                              <img
                                src="/content/images/homeDelivery/transfer.svg"
                                alt=""
                              />
                            </span>
                            {t('Easy script transfers')}
                          </li>
                          <li>
                            <span>
                              <img
                                src="/content/images/homeDelivery/lock.svg"
                                alt=""
                              />
                            </span>
                            {t('Confidential and safe')}
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <div className="newdeliverydata">
                        {!isSigninClick && referrerUser.firstName ? (
                          <React.Fragment>
                            <div className="newSignupHeading">
                              <h2
                                className="title headingMargin"
                                id="dialogTitleHeading"
                              >
                                Welcome to SingleCare!
                              </h2>
                              <p className="refferText">{`You were referred by ${referrerUser.firstName} ${referrerUser.lastName}.`}</p>
                              <p className="describeText">
                                {t('Members get our lowest prices')}&nbsp;
                                <span>
                                  {t('Sign-up-new')}&nbsp;
                                  <strong>{t('FREE')}</strong>
                                  &nbsp;
                                  {t('to get exclusive discounts')}
                                </span>
                                <br className="desktop-only" />
                                &nbsp;{t('Enter your email to get started')}.
                              </p>
                            </div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {getHeading()}
                            <h3 className="headingLabelText">
                              {t('Enter your email to get started')}
                            </h3>
                          </React.Fragment>
                        )}
                        <div className="separatorLine"></div>
                      </div>
                    )}
                    <form className="commonForm" autoComplete="on">
                      <Input
                        parentClass="fullWidth"
                        label={t('Email')}
                        type="email"
                        name="email"
                        value={email}
                        placeholder={t('example@domain.com')}
                        handleInputChange={handleEmailChange}
                        handleInputBlur={handleEmailBlur}
                        error={emailErr}
                        autoFocus={true}
                        autoComplete="email"
                      />
                      {showLoader ? (
                        <img
                          src="/content/images/loader/loading.gif"
                          alt="loader"
                          className="searchBarLoader"
                          role="progressbar"
                        />
                      ) : (
                        <button
                          className="dialogComponent button pink"
                          onClick={handleContinueClick}
                        >
                          {t('Continue')}
                        </button>
                      )}
                      <div className="helper-text">
                        {isFromHomeDelivery ? (
                          <p>
                            {lang === 'es' && t('apply')} &nbsp;
                            <a
                              className="dialogComponent textCapitalize"
                              rel="noopener noreferrer"
                              target="_blank"
                              href={_.withLocale(lang, '/terms-and-conditions')}
                            >
                              {t('Terms & Conditions')}
                            </a>
                            &nbsp;
                            {lang === 'en' && t('apply')}.
                          </p>
                        ) : (
                          <React.Fragment>
                            <p>
                              {t('Some exclusions apply. See')}&nbsp;
                              <a
                                className="dialogComponent textCapitalize"
                                rel="noopener noreferrer"
                                target="_blank"
                                href={_.withLocale(
                                  lang,
                                  '/terms-and-conditions'
                                )}
                              >
                                {t('terms & conditions')}
                              </a>
                            </p>
                            <button
                              tabIndex="0"
                              className="dialogComponent linkText whiteFocus"
                              onClick={() => hideAuthenticateModal()}
                              onMouseDown={() => hideAuthenticateModal()}
                              onKeyPress={e => {
                                if (e.key === 'Enter') {
                                  hideAuthenticateModal();
                                }
                              }}
                              role="button"
                              aria-label="closes dialog"
                            >
                              {t('Not right now')}
                            </button>
                          </React.Fragment>
                        )}
                      </div>
                    </form>
                  </div>
                )}
                {userState === 1 && (
                  <EnterPassWordModal
                    email={email}
                    redirectUri={redirectUri}
                    quantity={quantity}
                    isFromHomeDelivery={isFromHomeDelivery}
                    hideAuthenticateModal={hideAuthenticateModal}
                  />
                )}
                {userState === 2 && <EmailSentModal email={email} />}
                {userState === 3 && (
                  <SignupHomeDelivery
                    email={email}
                    isFromHomeDelivery={isFromHomeDelivery}
                    hideAuthenticateModal={
                      confirmationModal
                        ? handleConfirmation
                        : hideAuthenticateModal
                    }
                    hideAuthenticateModalAfterSignup={
                      hideAuthenticateModalAfterSignup
                    }
                  />
                )}
              </>
            )}
          </Dialog>
        </div>
      ) : (
        userState === 4 && (
          <ReferralSignupSuccess
            closeDialogHandler={referralSignupCloseHandler}
          ></ReferralSignupSuccess>
        )
      )}
    </React.Fragment>
  );
};

AuthenticateModal.propTypes = {
  hideAuthenticateModal: func,
  redirectUri: string,
  quantity: number,
  isFromHomeDelivery: bool,
  referrerUser: object,
  skipEmailScreen: bool,
  isSigninClick: bool
};

AuthenticateModal.defaultProps = {
  hideAuthenticateModal: () => {},
  redirectUri: '',
  quantity: 0,
  isFromHomeDelivery: false,
  referrerUser: {},
  skipEmailScreen: false,
  isSigninClick: false
};

export default AuthenticateModal;
